import { render } from "./tab-menu.vue?vue&type=template&id=adfa06be&ts=true"
import script from "./tab-menu.ts?vue&type=script&lang=ts&external"
export * from "./tab-menu.ts?vue&type=script&lang=ts&external"

import "./tab-menu.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__